<template>
  <section class="hero_Section mb-4">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-10">
          <div class="heading py-4">
            <h3 class="text-start fw-bolder text-white">{{ heading }}</h3>
          </div>
        </div>
        <div class="col-12 col-sm-2">
          <div class="heading py-sm-4">
            <router-link :to="backurl" class="text-decoration-none"
              ><h3 class="text-start fw-bolder text-white text-sm-end">
                Back
              </h3></router-link
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeroSection",
  props: {
    heading: String,
    backurl: String,
  },
};
</script>

<style>
.hero_Section {
  background: linear-gradient(119.9deg, #c629fd 8.07%, #9745ff 100%);
}
</style>